/**
 * Recognises the backend's `SCENARIO_REVISION_CONFLICT` refusal (SE-8340
 * contract) on a rejected scenario mutation — by extension code only, never
 * by message text.
 * @module features/squad-planning/utils/scenarioRevisionConflict
 */
import { collectGraphQLErrors } from "./collectGraphQLErrors";

/** Extension code the backend sets when `expectedRevision` is stale. */
export const SCENARIO_REVISION_CONFLICT_CODE = "SCENARIO_REVISION_CONFLICT";

/**
 * Whether the rejection is a stale-revision refusal.
 * @param error - The value the mutation rejected with
 * @returns `true` when any GraphQL error carries the conflict code
 */
export function isScenarioRevisionConflict(error: unknown): boolean {
  return collectGraphQLErrors(error).some(
    entry => entry.extensions?.code === SCENARIO_REVISION_CONFLICT_CODE
  );
}
